export const loggedoutReasons = {
  UNKNOWN_USER: "MESSAGE_UNKNOWN_USER",
  NORMAL_LOGOUT: "MESSAGE_NORMAL_LOGOUT"
}

